import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteUserUrl } from "../../config";
import { IUserState } from "../../common/types/userTypes";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";

const DELETE_USER: string = "deleteUser"

const initialState: IUserState = {
  status: Status.IDLE,
  error: null,
  msg: null
};

interface IDeleteUserResponse{
  data:IDeleteUserResponse,
  message:string,
}

interface IDeleteUserPayload{
  userId:string|number
}

export const deleteUser = createAsyncThunk(DELETE_USER, async (payload: IDeleteUserPayload, { rejectWithValue }) => {
    try {
      const response = await api.delete<IDeleteUserResponse>(deleteUserUrl+ `?userId=${payload.userId}`);
      const deleteModalResponse: IDeleteUserResponse = response.data;
      return deleteModalResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deleteUserModalSlice = createSlice({
  name: DELETE_USER,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteUser.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.deleteUser;


export default deleteUserModalSlice.reducer;